import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-add',
  templateUrl: './general-add.component.html',
  styleUrls: ['./general-add.component.scss']
})
export class GeneralAddComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
